import React from 'react';
import Navbar from './Navbar';
import Sidebar from './Sidebar';

const MainLayout = ({children, currentYear, onYearChange}) => {
    const [sidebarOpen, setSidebarOpen] = React.useState(false);

    return (
        <div className="flex h-screen">
            {/* Sidebar para desktop */}
            <div className="hidden md:flex md:w-64 md:flex-col md:fixed md:inset-y-0">
                <Sidebar/>
            </div>

            {/* Contenido principal */}
            <div className="md:pl-64 flex flex-col flex-1">
                <Navbar
                    currentYear={currentYear}
                    onYearChange={onYearChange}
                    setSidebarOpen={setSidebarOpen}/> {/* Sidebar móvil */}
                {
                    sidebarOpen && (
                        <div className="md:hidden">
                            <div className="fixed inset-0 flex z-40">
                                <div
                                    className="fixed inset-0 bg-gray-600 bg-opacity-75"
                                    onClick={() => setSidebarOpen(false)}></div>
                                <div className="relative flex-1 flex flex-col max-w-xs w-full bg-white">
                                    <div className="absolute top-0 right-0 -mr-12 pt-2">
                                        <button
                                            className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                                            onClick={() => setSidebarOpen(false)}>
                                            <span className="sr-only">Cerrar sidebar</span>
                                            <svg
                                                className="h-6 w-6 text-white"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor">
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth="2"
                                                    d="M6 18L18 6M6 6l12 12"/>
                                            </svg>
                                        </button>
                                    </div>
                                    <Sidebar/>
                                </div>
                            </div>
                        </div>
                    )
                }

                <main className="flex-1">
                    <div className="py-6">
                        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                            {children}
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default MainLayout;